/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { SecurityRole } from '../model/securityRole';
import { SecurityRoleCreateRequest } from '../model/securityRoleCreateRequest';
import { SecurityRoleKeys } from '../model/securityRoleKeys';
import { SecurityRoleUpdateRequest } from '../model/securityRoleUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class SecurityRoleService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createSecurityRole
     * Creates a new security role.
     * @param securityRoleCreateRequest the information needed to create a security role
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleCreateSecurityRole(securityRoleCreateRequest: SecurityRoleCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<SecurityRole>;
    public securityRoleCreateSecurityRole(securityRoleCreateRequest: SecurityRoleCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRole>>;
    public securityRoleCreateSecurityRole(securityRoleCreateRequest: SecurityRoleCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRole>>;
    public securityRoleCreateSecurityRole(securityRoleCreateRequest: SecurityRoleCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityRoleCreateRequest === null || securityRoleCreateRequest === undefined) {
            throw new Error('Required parameter securityRoleCreateRequest was null or undefined when calling securityRoleCreateSecurityRole.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SecurityRole>(`${this.configuration.basePath}/securityRoles`,
            securityRoleCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteSecurityRole
     * Deletes an existing security role.
     * @param securityRoleName the security role name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleDeleteSecurityRole(securityRoleName: string, observe?: 'body', reportProgress?: boolean): Observable<SecurityRole>;
    public securityRoleDeleteSecurityRole(securityRoleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRole>>;
    public securityRoleDeleteSecurityRole(securityRoleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRole>>;
    public securityRoleDeleteSecurityRole(securityRoleName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityRoleName === null || securityRoleName === undefined) {
            throw new Error('Required parameter securityRoleName was null or undefined when calling securityRoleDeleteSecurityRole.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<SecurityRole>(`${this.configuration.basePath}/securityRoles/${encodeURIComponent(String(securityRoleName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSecurityRole
     * Retrieves an existing security role.
     * @param securityRoleName the security role name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleGetSecurityRole(securityRoleName: string, observe?: 'body', reportProgress?: boolean): Observable<SecurityRole>;
    public securityRoleGetSecurityRole(securityRoleName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRole>>;
    public securityRoleGetSecurityRole(securityRoleName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRole>>;
    public securityRoleGetSecurityRole(securityRoleName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityRoleName === null || securityRoleName === undefined) {
            throw new Error('Required parameter securityRoleName was null or undefined when calling securityRoleGetSecurityRole.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SecurityRole>(`${this.configuration.basePath}/securityRoles/${encodeURIComponent(String(securityRoleName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getSecurityRoles
     * Gets a list of security role keys for all security roles registered in the system. The result list is sorted by security role name in ascending order.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleGetSecurityRoles(observe?: 'body', reportProgress?: boolean): Observable<SecurityRoleKeys>;
    public securityRoleGetSecurityRoles(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRoleKeys>>;
    public securityRoleGetSecurityRoles(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRoleKeys>>;
    public securityRoleGetSecurityRoles(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SecurityRoleKeys>(`${this.configuration.basePath}/securityRoles`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateSecurityRole
     * Updates an existing security role.
     * @param securityRoleName the security role name
     * @param securityRoleUpdateRequest the information required to update a security role
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public securityRoleUpdateSecurityRole(securityRoleName: string, securityRoleUpdateRequest: SecurityRoleUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<SecurityRole>;
    public securityRoleUpdateSecurityRole(securityRoleName: string, securityRoleUpdateRequest: SecurityRoleUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SecurityRole>>;
    public securityRoleUpdateSecurityRole(securityRoleName: string, securityRoleUpdateRequest: SecurityRoleUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SecurityRole>>;
    public securityRoleUpdateSecurityRole(securityRoleName: string, securityRoleUpdateRequest: SecurityRoleUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (securityRoleName === null || securityRoleName === undefined) {
            throw new Error('Required parameter securityRoleName was null or undefined when calling securityRoleUpdateSecurityRole.');
        }
        if (securityRoleUpdateRequest === null || securityRoleUpdateRequest === undefined) {
            throw new Error('Required parameter securityRoleUpdateRequest was null or undefined when calling securityRoleUpdateSecurityRole.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<SecurityRole>(`${this.configuration.basePath}/securityRoles/${encodeURIComponent(String(securityRoleName))}`,
            securityRoleUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
